import { action, extendObservable } from 'mobx';

import ModelBase from './ModelBase';

export default class ContactListItem extends ModelBase {
  static className = 'ContactListItem';

  @action
  static fromJSON(id, json) {
    const result = super.fromJSON(id, json);

    if (!result.adName) {
      extendObservable(result, { adName: id });
    }

    return result;
  }
}



// WEBPACK FOOTER //
// ./src/store/ContactListItem.js